var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_Tips"),
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "60px", "label-position": "left" } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_ReconciliationDiffReason")
              }
            },
            [
              _c("el-input", {
                staticStyle: { width: "220px" },
                model: {
                  value: _vm.reason,
                  callback: function($$v) {
                    _vm.reason = $$v
                  },
                  expression: "reason"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary", no: "ok" }, on: { click: _vm.ok } },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }